import { ShieldCheck, Clock, DollarSign, CheckCircle2 } from "lucide-react";

export function TrustSignals() {
  return (
    <section
      className="bg-gray-50 py-16 border-b border-gray-200"
      aria-label="Trust Signals"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16 text-center mb-16">
          <div className="flex flex-col items-center">
            <span className="text-4xl md:text-5xl font-black text-salt-dark mb-2">
              12
            </span>
            <span className="text-xs font-bold uppercase tracking-widest text-gray-500">
              Regional Salt Hubs
            </span>
          </div>
          <div className="hidden md:block w-px h-16 bg-gray-300"></div>
          <div className="flex flex-col items-center">
            <span className="text-4xl md:text-5xl font-black text-salt-dark mb-2">
              100+
            </span>
            <span className="text-xs font-bold uppercase tracking-widest text-gray-500">
              Plant Growers
            </span>
          </div>
          <div className="hidden md:block w-px h-16 bg-gray-300"></div>
          <div className="flex flex-col items-center">
            <span className="text-4xl md:text-5xl font-black text-salt-dark mb-2">
              250+
            </span>
            <span className="text-xs font-bold uppercase tracking-widest text-gray-500">
              Contractors Served
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-salt-orange/10 rounded-full flex items-center justify-center mb-4 text-salt-orange">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <span className="font-black uppercase tracking-widest text-xs text-salt-dark">
              Fully Insured & Bonded
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-salt-dark/10 rounded-full flex items-center justify-center mb-4 text-salt-dark">
              <Clock className="w-6 h-6" />
            </div>
            <span className="font-black uppercase tracking-widest text-xs text-salt-dark">
              24/7 Storm Dispatch
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-plant-green/10 rounded-full flex items-center justify-center mb-4 text-plant-green">
              <DollarSign className="w-6 h-6" />
            </div>
            <span className="font-black uppercase tracking-widest text-xs text-salt-dark">
              Commercial Tier Pricing
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-500/10 rounded-full flex items-center justify-center mb-4 text-blue-600">
              <CheckCircle2 className="w-6 h-6" />
            </div>
            <span className="font-black uppercase tracking-widest text-xs text-salt-dark">
              Verified Supply Network
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
